import React, {useEffect, useRef} from 'react';

import {trackEvent} from 'analytics/Analytics';
import BenchlingConfig from 'BenchlingConfig';
import {LLM_CHAT_ANALYTICS_ACTIONS} from 'constants/analytics-products/LLMChatConstants';
import {AgentType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {isAgentTypeEnabled} from 'llm/chat-library/sidepanel/ChatTypeUtil';
import {ButtonSize} from 'ui-library/buttons/Button';
import APIUtil from 'util/APIUtil';

import StartChatInput from './StartChatInput';

interface InventoryAskButtonProps {
  itemId: string;
}

export default function InventoryAskButton({itemId}: InventoryAskButtonProps): JSX.Element | null {
  const hasTrackedImpression = useRef(false);
  const modelType = APIUtil.apiIdToType(itemId);
  const askAgentType = BenchlingConfig.LLM_ENABLE_ASSISTANT_AGENT ? AgentType.ASSISTANT : AgentType.ASK;

  useEffect(() => {
    hasTrackedImpression.current = false;
  }, [itemId]);

  useEffect(() => {
    if (isAgentTypeEnabled(askAgentType) && !hasTrackedImpression.current) {
      hasTrackedImpression.current = true;
      trackEvent(LLM_CHAT_ANALYTICS_ACTIONS.VIEWED_INVENTORY_ASK_BUTTON, {
        itemId,
        modelType,
      });
    }
  }, [itemId, modelType, askAgentType]);

  if (!isAgentTypeEnabled(askAgentType)) {
    return null;
  }

  return (
    <StartChatInput
      itemId={itemId}
      agentType={askAgentType}
      buttonSize={ButtonSize.SMALL}
      extraAnalyticsProperties={{source: 'inventory'}}
    />
  );
}
